import React, { useState, useEffect } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import { programsApi } from '../../../api/adminApi';
import './ProgramView.css';

function ProgramView() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [program, setProgram] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!id) return;
    setLoading(true);
    setError('');
    programsApi
      .getOne(id)
      .then((data) => setProgram(data))
      .catch((err) => setError(err.userMessage || 'Failed to load program'))
      .finally(() => setLoading(false));
  }, [id]);

  const formatAge = (p) => {
    const min = p?.age_min ?? p?.ageMin;
    const max = p?.age_max ?? p?.ageMax;
    if (min != null && max != null && max > 0) return `${min}–${max}`;
    if (min != null) return `${min}+`;
    return '—';
  };

  const formatDate = (str) => {
    if (!str) return '—';
    try {
      const d = new Date(str);
      return isNaN(d.getTime()) ? str : d.toLocaleDateString(undefined, { dateStyle: 'medium' });
    } catch {
      return str;
    }
  };

  if (loading) {
    return <div className="admin-program-view-loading">Loading program…</div>;
  }

  if (error || !program) {
    return (
      <div className="admin-program-view">
        <div className="admin-program-view-header">
          <Link to="/admin/programs" className="admin-program-view-back">← Programs</Link>
        </div>
        <div className="admin-program-view-error" role="alert">
          {error || 'Program not found.'}
        </div>
      </div>
    );
  }

  return (
    <div className="admin-program-view">
      <div className="admin-program-view-header">
        <Link to="/admin/programs" className="admin-program-view-back">← Programs</Link>
        <h2>{program.name || program.title || program.programName || 'Program'}</h2>
        <div className="admin-program-view-actions">
          <button
            type="button"
            className="admin-program-view-btn admin-program-view-btn-edit"
            onClick={() => navigate('/admin/programs', { state: { editProgram: program } })}
          >
            Edit
          </button>
        </div>
      </div>

      <div className="admin-program-view-card">
        {(program.icon_url || program.iconUrl || program.photo_url) && (
          <div className="admin-program-view-media">
            {(program.icon_url || program.iconUrl) && (
              <div className="admin-program-view-icon">
                <img src={program.icon_url || program.iconUrl} alt="" />
              </div>
            )}
            {program.photo_url && (
              <div className="admin-program-view-photo">
                <img src={program.photo_url} alt="" />
              </div>
            )}
          </div>
        )}

        <dl className="admin-program-view-details">
          <div className="admin-program-view-row">
            <dt>Name</dt>
            <dd>{program.name || program.title || program.programName || '—'}</dd>
          </div>
          <div className="admin-program-view-row">
            <dt>Description</dt>
            <dd>{program.description || program.desc || '—'}</dd>
          </div>
          <div className="admin-program-view-row">
            <dt>Age range</dt>
            <dd>{formatAge(program)}</dd>
          </div>
          <div className="admin-program-view-row">
            <dt>Feature timeline</dt>
            <dd>{program.feature_timeline || program.featureTimeline || '—'}</dd>
          </div>
          <div className="admin-program-view-row">
            <dt>Teacher ratio</dt>
            <dd>{program.teacher_ratio || program.feature_ratio || program.featureRatio || '—'}</dd>
          </div>
          <div className="admin-program-view-row">
            <dt>Created</dt>
            <dd>{formatDate(program.created_at || program.createdAt)}</dd>
          </div>
          <div className="admin-program-view-row">
            <dt>Updated</dt>
            <dd>{formatDate(program.updated_at || program.updatedAt)}</dd>
          </div>
        </dl>
      </div>
    </div>
  );
}

export default ProgramView;
